module.exports = __webpack_public_path__ + "img/ic_kong_tiao.8336574c.png";